<template>
    <div>
      <a-drawer :title='title' :visible="visible" v-bind="drawerConfig" :body-style="{ paddingBottom: '80px' }"  @close="onClose">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" >
          <a-form-model-item ref="instructions_budget" label="投放类型及预算分配" prop="instructions_budget" :help="formErr.instructions_budget" :validateStatus='!formErr.instructions_budget||formErr.instructions_budget==""?"":"error"' >
            <a-input type="textarea"
                     :maxLength=3000
                     v-model="form.instructions_budget"
                     @change="(e) => { formErr.instructions_budget=''}"
                     @blur="(e) => {  form.instructions_budget = e.target.value.trim();}" />
          </a-form-model-item>
          <a-form-model-item ref="instructions_search" label="搜索广告账户结构" prop="instructions_search" :help="formErr.instructions_search" :validateStatus='!formErr.instructions_search||formErr.instructions_search==""?"":"error"' >
            <a-input type="textarea"
                     :maxLength=3000
                     v-model="form.instructions_search"
                     @change="(e) => { formErr.instructions_search=''}"
                     @blur="(e) => {  form.instructions_search = e.target.value.trim();}" />
          </a-form-model-item>
          <a-form-model-item ref="instructions_page" label="着陆页分析" prop="instructions_page" :help="formErr.instructions_page" :validateStatus='!formErr.instructions_page||formErr.instructions_page==""?"":"error"' >
            <a-input type="textarea"
                     :maxLength=3000
                     v-model="form.instructions_page"
                     @change="(e) => { formErr.instructions_page=''}"
                     @blur="(e) => {  form.instructions_page = e.target.value.trim();}" />
          </a-form-model-item>
          <a-form-model-item ref="status" label="状态" prop="status" :help="formErr.status" :validateStatus='!formErr.status||formErr.status==""?"":"error"'>
            <a-radio-group v-model="form.status"  >
              <a-radio :value="1"> 启用 </a-radio>
              <a-radio :value="2"> 停用 </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >
            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
                取消
            </a-button>
        </div>
      </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "instructionForm",
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},
        },
        data() {
            return {
                drawerConfig ,
                form: {
                  id:"",
                  instructions_budget:"",
                  instructions_search:"",
                  instructions_page:"",
                  status:1,
                },
                formErr: {
                  status:'',
                  instructions_budget:"",
                  instructions_search:"",
                  instructions_page:"",
                },
                rules: {
                  instructions_budget: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders(rule, value, callback)}  , trigger: "blur"  },],
                  instructions_search: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders1(rule, value, callback)}  , trigger: "blur"  },],
                  instructions_page: [{required: true, message: "请输入内容", },{validator:(rule, value, callback)=>{this.validatePlaceholders2(rule, value, callback)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){

            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA({id: a}).then(res => {
                      console.log(res.data)
                        let data=res.data.data.info
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            }
        },
        mounted(){
        },
        methods: {
            validatePlaceholders(rule, value, callback) {
                if (!value) {
                    this.formErr.instructions_budget = '请输入内容'
                    callback(new Error('请输入内容'))
                    return
                }
                const requiredPlaceholders = ['{product_name}', '{industry_category}', '{landing_pages}', '{seed_keywords}', '{daily_budget}']
                const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
                if (missing.length > 0) {
                    const placeholderNames = {
                        '{product_name}': '{product_name}',
                        '{industry_category}': '{industry_category}',
                        '{landing_pages}': '{landing_pages}',
                        '{seed_keywords}': '{seed_keywords}',
                        '{daily_budget}': '{daily_budget}',
                    }
                    const missingNames = missing.map(p => placeholderNames[p])
                    this.formErr.instructions_budget = `句式中须包含${missingNames.join('、')}`
                    callback(new Error(`句式中须包含${missingNames.join('、')}`))
                } else {
                    this.formErr.instructions_budget = ''
                    callback()
                }
            },
            validatePlaceholders1(rule, value, callback) {
              if (!value) {
                this.formErr.instructions_search = '请输入内容'
                callback(new Error('请输入内容'))
                return
              }
              const requiredPlaceholders = ['{product_name}', '{industry_category}', '{landing_pages}', '{seed_keywords}', '{daily_budget}', '{Part1}']
              const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
              if (missing.length > 0) {
                const placeholderNames = {
                  '{product_name}': '{product_name}',
                  '{industry_category}': '{industry_category}',
                  '{landing_pages}': '{landing_pages}',
                  '{seed_keywords}': '{seed_keywords}',
                  '{daily_budget}': '{daily_budget}',
                  '{Part1}': '{Part1}',
                }
                const missingNames = missing.map(p => placeholderNames[p])
                this.formErr.instructions_search = `句式中须包含${missingNames.join('、')}`
                callback(new Error(`句式中须包含${missingNames.join('、')}`))
              } else {
                this.formErr.instructions_search = ''
                callback()
              }
            },
            validatePlaceholders2(rule, value, callback) {
              if (!value) {
                this.formErr.instructions_page = '请输入内容'
                callback(new Error('请输入内容'))
                return
              }
              const requiredPlaceholders = ['{product_name}', '{industry_category}', '{landing_pages}', '{seed_keywords}', '{daily_budget}']
              const missing = requiredPlaceholders.filter(placeholder => !value.includes(placeholder))
              if (missing.length > 0) {
                const placeholderNames = {
                  '{product_name}': '{product_name}',
                  '{industry_category}': '{industry_category}',
                  '{landing_pages}': '{landing_pages}',
                  '{seed_keywords}': '{seed_keywords}',
                  '{daily_budget}': '{daily_budget}',
                }
                const missingNames = missing.map(p => placeholderNames[p])
                this.formErr.instructions_page = `句式中须包含${missingNames.join('、')}`
                callback(new Error(`句式中须包含${missingNames.join('、')}`))
              } else {
                this.formErr.instructions_page = ''
                callback()
              }
            },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  status:'',
                  instructions_budget:"",
                  instructions_search:"",
                  instructions_page:"",
                }
              this.form = {
                status:1,
                instructions_budget:"",
                instructions_search:"",
                instructions_page:"",
              },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))

                      this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT

                      submitForm(url, subData).then(res => {
                        console.log(res)

                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
form .ant-mentions, form textarea.ant-input {
  height: 200px;
}
</style>
